<template>
  <!-- 模态组件  -->
  <div class="modal-backdrop">
     <div class="modal" >
        <div class="modal-header">
          <h3>{{title}}</h3>
        </div>
        <div class="modal-body">
            <!-- 插槽 父组件传入的内容 -->
            <slot name="formData"></slot>
        </div>
        <div class="modal-footer">
            <!-- <button type="button" class="btn-confirm" @click="confirm">确认</button>
            <button type="button" class="btn-close" @click="closeSelf">关闭</button> -->
            <el-button type="primary" size="small" v-on:click="confirm">确认</el-button>
            <el-button size="small" v-on:click="closeSelf">关闭</el-button>
        </div>
    </div>
  </div>
</template>
 
<style>
.modal-backdrop { 
    position: fixed; 
    top: 0; 
    right: 0; 
    bottom: 0; 
    left: 0; 
    background-color: rgba(0,0,0,.3); 
    display: flex; 
    justify-content: center; 
    align-items: center; 
    z-index: 999;
}
.modal { 
    background-color: #fff; 
    box-shadow: 2px 2px 20px 1px; 
    overflow-x:auto; 
    display: flex; 
    flex-direction: column;
    border-radius: 16px;
    width: 500px;
} 
.modal-header { 
    border-bottom: 1px solid #eee; 
    color: #313131; 
    justify-content: center;
    padding: 15px; 
    display: flex; 
} 
.modal-footer { 
    border-top: 1px solid #eee; 
    justify-content: center;
    padding: 15px; 
    display: flex; 
} 
.modal-body { 
    position: relative; 
    padding: 20px 10px 0px 10px; 
}
.btn-close, .btn-confirm {    
    border-radius: 8px;
    margin-left:16px;
    width:56px;
    height: 36px;
    border:none;
    cursor: pointer;
}
.btn-close {
    color: #313131;
    background-color:transparent;
}
.btn-confirm {
    color: #fff; 
    background-color: #2d8cf0;
}
 
 
</style>
 
<script>
export default {
  name: 'modal',
  props: {  // 父组件传入的参数
        title:{
            type:String,
            default:""
        }
  },
  data() {
    return {       
    }
  }, 
  methods: {    
    closeSelf() {
        this.$emit("close");       
    },
    confirm(){
        this.$emit("confirm");
    }
  }
}
</script>